// extracted by mini-css-extract-plugin
module.exports = {"cont":"sponsers-module--cont--11vxJ","imgDiv":"sponsers-module--imgDiv--1U1B1","img":"sponsers-module--img--3w6wY"};